import { createStackNavigator } from '@react-navigation/stack'
import * as React from 'react'
import { documentTitle } from '../../static/Routes'

const Stack = createStackNavigator()
const Landing = React.lazy(() => import('../../screens/LandingScreen'))
const Rsil = React.lazy(() => import('../../screens/Rsil'))

export const HomeLandingStack = () => {
  return (
    <>
      <Stack.Screen
        name="jiopay"
        component={Landing}
        options={{
          title: documentTitle.landingScreen,
        }}
      />
      <Stack.Screen
        name="rsil"
        component={Rsil}
        options={{
          title: documentTitle.rsil,
        }}
      />
    </>
  )
}
